export default "__VITE_ASSET__a92a39b2__"